import { combineReducers } from 'redux';
import common from './common';
import invest from "./invest"
import profile from './profile';
const reducers = combineReducers({
    common,invest,profile
});

export default reducers;
